var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocs = function SvgDocs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m13.683 2.52.673-.74zM3.778 3h8.56V1h-8.56zM17 7.33v8.892h2V7.33zM16.222 17H3.778v2h12.444zM3 16.222V3.778H1v12.444zm.778.778A.78.78 0 0 1 3 16.222H1A2.78 2.78 0 0 0 3.778 19zM17 16.222c0 .43-.348.778-.778.778v2A2.78 2.78 0 0 0 19 16.222zM13.01 3.26l3.663 3.33 1.345-1.48-3.662-3.33zM3.779 1A2.78 2.78 0 0 0 1 3.778h2c0-.43.348-.778.778-.778zM19 7.33a3 3 0 0 0-.982-2.22l-1.345 1.48a1 1 0 0 1 .327.74zM12.338 3a1 1 0 0 1 .673.26l1.345-1.48A3 3 0 0 0 12.338 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10 14V9H9m1 5H9m1 0h1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 6,
    r: 1,
    fill: "#000"
  })));
};
export default SvgDocs;